import axiosInstance from '../../../constants/axiosInstance';
import { LogbookTemplatesPage } from '../types/listTypes';

export const fetchLogbookList = async ({
    pageParam = 1,
    queryKey,
    plantId,
    limit,
}: any): Promise<LogbookTemplatesPage> => {
    const [, searchString] = queryKey;
    const { data } = await axiosInstance().post(`/ocr/getListOfLogbookAssetConfiguration`, {
        logbooks: searchString,
        pageNumber: pageParam,
        limit,
        assetId: plantId,
    });
    return {
        logbooks: data.data.listOfLogbookConfiguration,
        totalPages: data.data.totalPages,
        totalCount: data.data.totalCount,
        currentPage: pageParam,
    };
};

export const deleteLogbook = async (logbookId: string) => {
    const { data } = await axiosInstance().post(`/ocr/deleteLogbookAssetConfiguration`, {
        id: logbookId,
    });
    return data;
};

export const fetchLogbookConfigurationDetails = async (logbookAssetConfigurationId: string, signal?: AbortSignal) => {
    const { data } = await axiosInstance().post(
        `/ocr/getLogbookAssetConfigurationDetails`,
        { id: logbookAssetConfigurationId },
        { signal },
    );
    return data;
};
